import React, { useEffect } from "react";

const Banner = () => {
  useEffect(() => {
    window.initializeSlickSlider();
  }, []);

  return (
    <>
      <div className="banner-sec">
        <div className="container">
          <div className="slick" id="slickslider">
            <img
              className="creator-item"
              src="assets/images/creator-1.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-2.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-3.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-4.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-5.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-6.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-7.png"
              alt=""
            />
            <img
              className="creator-item"
              src="assets/images/creator-5.png"
              alt=""
            />
          </div>
          <div className="open-sea-btn">
            <a
              href={"https://opensea.io/collection/supercreatorsorigins"}
              target="_blank"
              rel="noreferrer"
              className="btn"
            >
              View on Opensea
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
